var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h34v34H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.643 30.527.44 26.72c2.767-4.46 4.2-9.245 4.297-14.356V2.55h10.645v9.082c-.033 3.515-.944 7.129-2.735 10.84-1.595 3.255-3.597 5.94-6.005 8.056zm15.722 0-6.2-3.808c2.864-4.623 4.361-9.375 4.491-14.258V2.549h10.645v8.887c0 3.222-.83 6.632-2.49 10.229-1.66 3.597-3.809 6.551-6.446 8.862z",
    fill: "#0171B7",
    fillRule: "nonzero"
  }))));
};
export default SvgQuote;